export interface IFeishuState {
  redirect?: string;
  queryStr?: string;
}

export function encodeFeishuState(state: IFeishuState): string {
  return btoa(JSON.stringify(state));
}

export function decodeFeishuState(state?: string): IFeishuState {
  if (!state) return {};
  try {
    const obj = JSON.parse(atob(state));
    return obj && typeof obj === 'object' ? obj : {};
  } catch (e) {
    return {};
  }
}
